import type { FigmaIconProps } from './types';

export const IconFigmaMoreHorizontal = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.0008 12.0002C3.0008 10.8961 3.89536 9.9992 5.0008 9.9992C6.10613 9.99927 7.0008 10.8961 7.0008 12.0002C7.00067 13.1041 6.10613 14.0011 5.0008 14.0012C3.89536 14.0012 3.00093 13.1041 3.0008 12.0002ZM9.99982 12.0002C9.99982 10.8961 10.8946 9.99933 11.9998 9.9992C13.1053 9.9992 13.9998 10.8961 13.9998 12.0002C13.9997 13.1041 13.1053 14.0012 11.9998 14.0012C10.8946 14.001 9.99995 13.1041 9.99982 12.0002ZM16.9998 12.0002C16.9998 10.8965 17.8935 9.99953 18.9988 9.9992C20.1043 9.9992 20.9988 10.8961 20.9988 12.0002C20.9987 13.1041 20.1043 14.0012 18.9988 14.0012C17.8935 14.0008 17 13.1037 16.9998 12.0002Z"
      fill={color}
    />
  </svg>
);
